function c(t, r) {
  var l = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (l != null) {
    var u, f, o, n, i = [], e = !0, a = !1;
    try {
      if (o = (l = l.call(t)).next, r === 0) {
        if (Object(l) !== l)
          return;
        e = !1;
      } else
        for (; !(e = (u = o.call(l)).done) && (i.push(u.value), i.length !== r); e = !0)
          ;
    } catch (y) {
      a = !0, f = y;
    } finally {
      try {
        if (!e && l.return != null && (n = l.return(), Object(n) !== n))
          return;
      } finally {
        if (a)
          throw f;
      }
    }
    return i;
  }
}
export {
  c as default
};
//# sourceMappingURL=iterableToArrayLimit.js.map
